import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IPayrollRates, PayrollRateKey } from "../../interface/payrollShuttle";

export const setPayrollRate = async (
    key: PayrollRateKey,
    value: number,
    token: string,
    setRates: (rates: IPayrollRates) => void,
    dispatch: Function,
    setError: Function
) => {
    try {
        const response = await axios.post(
            `${urlAPI}/payroll-rates/`,
            { key, value },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        setRates(response.data.message);
        dispatch(showSnackbar("Taux mis à jour avec succès.", "success"));
    } catch (error: any) {
        console.error(error);
        setError("Impossible de mettre à jour ce taux.");
        dispatch(showSnackbar("Erreur lors de la mise à jour du taux.", "error"));
    }
};
